var render = function render(){var _vm=this,_c=_vm._self._c;return _c('category',{attrs:{"name":"Text Components","categorystyle":"text_components_category"}},[_c('MinecraftFormattingMenu',{ref:"formatting",staticClass:"minecraft_formatting",on:{"insert":_vm.formattingInsert,"fontSelected":_vm.fontSelected}}),_c('block',{attrs:{"type":"text_component"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }